<template>
<template v-for="date in offre.acf.DATESs" :key="date">
    <span class="date" v-if="date.date_courante == true">
        <template v-if="date.Datededebut == date.Datedefin"> 
            {{ this.returnDateFormat(date.Datededebut) }}
        </template>
        <template v-else>
            {{ $t("date.du") }} {{ this.returnDateFormat(date.Datededebut) }} {{ $t("date.au") }} {{ this.returnDateFormat(date.Datedefin) }}
        </template>
    </span>
</template>
</template>
<script>
export default {
  name: 'DatesView',   
  props: ['offre'],
  methods : {
    returnDateFormat(date) {
        let date_format = date.split('-');
        date_format = date_format[2]+'/'+date_format[1]+'/'+date_format[0];
        return date_format;
    }
  },
  mounted() {
  }
}
</script>
<style scoped>
</style>  